import React, { useEffect, useRef } from 'react'
import { Link } from 'gatsby'
import { removeFoldersFromUrl } from '@/helpers/removeFoldersFromUrl'
import { withTrailingSlash } from '@/helpers/withTrailingSlash'
import { SwitchElementProps } from './types'

export function SwitchElement({ option, onOptionClick, active, alternates, currentLang }: SwitchElementProps) {
  const ref = useRef<any>(null)
  const translatedPath =
    alternates?.length && alternates.find((alternate) => alternate.full_slug.startsWith(option.code))
  const redirectUrl = translatedPath ? translatedPath?.full_slug : option.code
  const href = removeFoldersFromUrl(redirectUrl)

  useEffect(() => {
    if (active === option.code) {
      ref?.current?.focus()
    }
  }, [active])

  const onMouseOverHandler = () => {
    ref?.current?.focus()
  }

  return (
    <li id={option.code} className="relative mb-4 last:mb-0" role="option" aria-selected={active === option.code}>
      <Link
        to={option.code === process.env.GATSBY_DEFAULT_LANGUAGE ? '/' : withTrailingSlash(href)}
        tabIndex={-1}
        ref={ref}
        onClick={onOptionClick}
        onMouseOver={onMouseOverHandler}
        onFocus={onMouseOverHandler}
        aria-selected={currentLang.code === option.code}
        className="w-full text-text-dark-900 rounded border-1 border-transparent text-bodyM text-left px-12 py-8 aria-selected:text-primary-500 aria-selected:font-bold aria-selected:bg-primary-200 aria-selected:border-primary-500 hover:bg-primary-100 focus:bg-primary-100  active:bg-primary-400  block transition-all duration-300 !outline-no-offset"
      >
        {option.name}
      </Link>
    </li>
  )
}
